import { render, staticRenderFns } from "./AIAlarmListDialog.vue?vue&type=template&id=2bdaffd1&scoped=true"
import script from "./AIAlarmListDialog.vue?vue&type=script&lang=js"
export * from "./AIAlarmListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdaffd1",
  null
  
)

export default component.exports